import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { BrMaskerModule } from 'br-mask';

let UiCTextValueComponent = class UiCTextValueComponent {
    constructor() {
        this.editValue = false;
        this.onChange = new EventEmitter();
    }
    onChangeValue() {
        this.onChange.emit(this.inputValue.replaceAll('.', '').replace(',', '.'));
    }
    valid() {
        this.inputValue = this.inputValue.replace(/^0+/, '');
        const value = Number(this.inputValue.replace(/[^0-9]/g, ''));
        if (this.editValue && this.minPayment <= value && this.maxPayment <= value) {
            this.inputValid = true;
        }
        else {
            this.inputValid = false;
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCTextValueComponent.prototype, "inputMode", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCTextValueComponent.prototype, "inputValue", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCTextValueComponent.prototype, "inputDestinary", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCTextValueComponent.prototype, "editValue", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCTextValueComponent.prototype, "maxPayment", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCTextValueComponent.prototype, "minPayment", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCTextValueComponent.prototype, "onChange", void 0);
UiCTextValueComponent = __decorate([
    Component({
        selector: 'ui-c-text-value',
        template: "<div class=\"text-value-component d-flex flex-column align-items-center justify-content-around\" (change)=\"onChangeValue()\">\n  <ion-text class=\"ion-text-center\">\n    <h2 class=\"font-weight-bold\">\n      {{ 'CASH_OUT.TRANSFER_RESUME.VALUE_RESUME.YOU_ARE' | wlpTranslate }} {{ this.inputMode }}:\n    </h2>\n    <ion-row class=\"ion-justify-content-center d-flex align-items-end\">\n      <ion-item class=\"d-flex flex-row justify-content-center\" *ngIf=\"!editValue\">\n        <p class=\"d-flex align-items-end p-value\">\n          <span class=\"align-self-start\">R$</span>\n          <span class=\"money green-text\">{{ this.inputValue }}</span>\n        </p>\n      </ion-item>\n      <ion-item class=\"d-flex flex-row justify-content-center text-center\" *ngIf=\"editValue\">\n        <span class=\"icn-holder\" class=\"align-self-start\"> R$ </span>\n        <ion-input (change)=\"$event.target.value = $event.target.value.toUpperCase()\"\n          [brmasker]=\"{money: true, thousand: '.',  decimalCaracter: ',', decimal: '2'}\"\n          class=\"ion-input\"\n          prefix=\"R$\"\n          placeholder=\"0,00\"\n          maxlength=\"13\"\n          [(ngModel)]=\"inputValue\"\n          (ionChange)=\"valid()\"\n        >\n        </ion-input>\n      </ion-item>\n    </ion-row>\n    <ion-row class=\"ion-justify-content-center\">\n      <div class=\"error-messages\">\n        <ng-container>\n          <div class=\"error-message\" *ngIf=\"!inputValid && editValue\">\n            {{ 'CASH_OUT.TRANSFER_RESUME.INFO_VALUE' | wlpTranslate }}\n          </div>\n        </ng-container>\n      </div>\n    </ion-row>\n    <p *ngIf=\"inputDestinary != null\">\n      {{ 'CASH_OUT.TRANSFER_RESUME.VALUE_RESUME.TO' | wlpTranslate }} {{ this.inputDestinary }}\n    </p>\n  </ion-text>\n</div>\n",
        styles: ["h1,h2{color:var(--ui-t-color-dark)!important}.money{font-size:30pt}.text-value-component ion-input{font-size:1.5em}"]
    })
], UiCTextValueComponent);

let UiCTextValueModule = class UiCTextValueModule {
};
UiCTextValueModule = __decorate([
    NgModule({
        declarations: [UiCTextValueComponent],
        imports: [
            CommonModule,
            IonicModule,
            FormsModule,
            BrMaskerModule,
            UiBsTranslateModule,
        ],
        exports: [
            UiCTextValueComponent
        ]
    })
], UiCTextValueModule);

export { UiCTextValueComponent, UiCTextValueModule };
//# sourceMappingURL=wlp-ui-c-text-value.js.map
